var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./employee-form-errors.j2"] = require( "./employee-form-errors.j2" );
dependencies["./employee-form-fields.j2"] = require( "./employee-form-fields.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/employee-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"profileShowErrors") && runtime.memberLookup(((lineno = 0, colno = 50, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["errors"]))),"location") == "employee-form") {
output += "\n\n    <form novalidate class=\"c-form js-employee-form js-account-errors\" name=\"employee-form\">\n\n";
;
}
else {
output += "\n\n    <form novalidate class=\"c-form js-employee-form\" name=\"employee-form\">\n\n";
;
}
output += "\n\n";
var t_1;
t_1 = "employee-form";
frame.set("location", t_1, true);
if(frame.topLevel) {
context.setVariable("location", t_1);
}
if(frame.topLevel) {
context.addExport("location", t_1);
}
output += "\n\n";
env.getTemplate("./employee-form-errors.j2", false, "account/templates/partials/employee-form.j2", null, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
t_2.render(context.getVariables(), frame, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
output += t_3
output += "\n\n";
env.getTemplate("./employee-form-fields.j2", false, "account/templates/partials/employee-form.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n\n</form>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/employee-form.j2"] , dependencies)